import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { logAnalyticsEvent } from './Firebase';
import Layout from './components/Layout';
import Home from './components/sections/Home';
import WorkPage from './components/work/WorkPage';

function PageviewTracker() {
  const location = useLocation();

  useEffect(() => {
    logAnalyticsEvent('page_view', {
      page_path: location.pathname,
      page_title: document.title,
    });
  }, [location]);

  return null;
}

function App() {
  return (
    <Router>
      <PageviewTracker />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="work/:slug" element={<WorkPage />} />
          {/* Old URLs now live on the single page */}
          <Route path="about" element={<Navigate to="/" replace />} />
          <Route path="projects" element={<Navigate to="/" replace />} />
          <Route path="projects/:id" element={<Navigate to="/" replace />} />
          <Route path="gallery" element={<Navigate to="/" replace />} />
          <Route path="contact" element={<Navigate to="/" replace />} />
          <Route path="portfolio/:id" element={<Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
